import parse from 'html-react-parser';
import { isDefined } from '../isDefined';

export function replacer(option, key) {
  if (!isDefined(option)) {
    throw new Error(`[replacer] Option is not defined`)
  }

  if (!isDefined(key)) {
    throw new Error(`[replacer] Key is not defined`)
  }

  let regExp = /{\{(.+?)\}\}/g;
  let value = option[key];
  let valueIsTemplate = value.search(regExp);
  let valueNew = value;
  let valueMatch;
  let valueKey;

  if (valueIsTemplate >- 1) {
    valueMatch = value.match(regExp)[0];
    valueKey = valueMatch.replace('{{', '').replace('}}', '');
    valueNew = valueNew.replace(regExp, option[valueKey] || 'unknown');
  }

  return parse(valueNew);
}
